<template>
  <v-card elevation="1" class="main__table">
    <v-data-table
      :headers="myHeaders"
      :items="items"
      :item-key="itemKey"
      :single-select="singleSelect"
      :loading-text="loadingText"
      :dense="dense"
      :no-data-text="noDataText"
      :page.sync="page"
      :items-per-page="limit"
      :custom-filter="customFilter"
      :show-select="showSelect"
      :loading="loading"
      @click:row="rowClickEvent"
      hide-default-footer
      :options.sync="optionsObj"
      :sortBy.sync="sortAr"
      v-model="selectedItems"
      mobile-breakpoint="990"
      :item-class="itemRowBackground"
      :fixed-header="true"
      :height="heightOfTableresult"
    >
<!-- height="560"-->

      <template slot="top" slot-scope="scope">
        <slot name="top" v-bind="scope" />
      </template>
      <!-- eslint-disable-next-line -->
      <template v-for="field in headers" :v-sticky="1" :slot="slotName(field)" slot-scope="scope">
        <slot class="ma-0 pa-0 font-weight-bold" :name="slotName(field)" v-bind="scope">{{
          scope.item[field.value]
        }}</slot>
      </template>

      <template slot="top" slot-scope="scope">
        <slot name="top" v-bind="scope" />
      </template>
      <!-- eslint-disable-next-line -->
      <template v-for="field in headers" :v-sticky="1" :slot="slotName(field)" slot-scope="scope">
        <slot class="ma-0 pa-0 font-weight-bold" :name="slotName(field)" v-bind="scope"
          >{{ scope.item[field.value] }}
        </slot>
      </template>


      <template v-slot:footer>
        <v-divider />

        <v-toolbar flat class="table-toolbar">
        
          <p style="margin: 0 12px 7px 12px">عدد الصفوف في الصفحة الواحدة</p>
          <v-text-field
            outlined
            :value="tempCounterOfShow"
            @input="updateTempCounterOfShow"
            @blur="updateCounterOfShow"
            dense
            width="10"
            height="35"
            color="purple"
            class="pruple-border"
            style="min-width: unset; max-width: 60px !important"
          ></v-text-field>
          
          <v-spacer></v-spacer>
          <div style="display: flex; align-items: center; position: absolute; right: 45%">
          
            <v-pagination
              v-model="page"
              :length="pages"
              :total-visible="5"
              @input="handlePageChange"
              color="primary"
              circle
            ></v-pagination>

          
          </div>
          <span class="font-italic mr-2">
            صفحه {{ page }}
            <span v-if="pagination != null"
              >من {{ pages }}, إجمالي البيانات {{ results }}</span
            >
          </span>
        </v-toolbar>
      </template>

    

      <!-- eslint-disable -->
      <template v-slot:item.data-table-select="{ item, isSelected, select }">
        <v-simple-checkbox
          :value="isSelected"
          @input="select($event)"
        ></v-simple-checkbox>
      </template>

    </v-data-table>
  </v-card>
</template>

<script>
import Axios from "axios";
import ProductivityReportFilter from "@/views/admin/Charts/ProductivityReportFilter";
import { EventBus } from '@/mixins/eventBus.js';

export default {
  name: "NewTableComponent",
  props: {
    dense: { default: false },
    pagination: { default: null },
    value: { default: 1 },
    limit: { default: 12 },
    headers: { required: true },
    formBody: { default: undefined },
    itemKey: { default: undefined },
    singleSelect: { default: false },
    showSelect: { default: false },
    items: { required: true },
    loading: { default: false },
    children: { type: Array },
    rowClickEvent: {
      type: Function,
      default: () => {},
    },
    loadingText: { default: "جاري تحميل البيانات ..." },
    noDataText: { default: "لا توجد بيانات" },
    selectedRows: { type: Array },
    customFilter: {
      default: () => {},
    },
    options: { required: false },
    sortBy: { required: false },
  },
  data() {
    return {
      selectedItems: [],
      duplicatedLogin: [],
      sum_of_each_source: [],
      body: {},
      dataVal: {
        total_recived_request_sum: 0,
        followed_basket_possible_to_sell_sum: 0,
        followed_basket_possible_to_sell_percentage_sum: 0,
        completed_request_sum: 0,
        completed_request_percentage_sum: 0,
        waiting_mm_status_sum: 0,
        waiting_fm_status_sum: 0,
        possible_to_sell_to_customer_sum: 0,

        sent_basket_sum: 0,
        sent_basket_reject_sum: 0,
        sent_basket_reject_percentage_sum: 0,
        sent_basket_percentage_sum: 0,

        sent_basket_funding_sum: 0,
        sent_basket_funding_reject_sum: 0,
        sent_basket_funding_reject_percentage_sum: 0,
        sent_basket_funding_percentage_sum: 0,

        sent_basket_mortgage_sum: 0,
        sent_basket_funding_send_basket_percentage_sum: 0,
        sent_basket_mortgage_send_basket_percentage_sum: 0,
        sent_basket_mortgage_reject_sum: 0,
        sent_basket_mortgage_percentage_sum: 0,
        sent_basket_mortgage_reject_percentage_sum: 0,
      },

      newOrderId: null,
      tempCounterOfShow: this.$store.state.counterOfShow,
    };
  },
  watch: {
    "$store.state.orderRequestId": {
      // immediate: true,
      handler(newOrderId, oldOrderId) {
        if (newOrderId) {
          this.itemRowBackground(this.newOrderId);
        }
      },
    },
    

    selectedItems(newlySelectedRows) {
      this.$emit("update:selectedRows", newlySelectedRows);
    },
    page(val) {
      this.$emit("update:page", val);
    },
    limit() {
      if (this.pagination != null) {
        return this.pagination.limit;
      }
      return 10;
    },
    "$store.state.tasksRequestId": {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.itemRowBackground(this.newOrderId);
        }
      },
    },

    "$store.state.tasksDetailsRequestId": {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.itemRowBackground(this.newOrderId);
        }
      },
    },
  },
  computed: {
    heightOfTableresult(){
      if(this.$store.state.counterOfShow > 10){
        return "600";
      }else{
        return "";
      }
    },
    returnDailyReportPlace() {
      return (
        window.location.pathname === "/salesManager/chart/dailyPerformance" ||
        window.location.pathname === "/admin/charts/dailyPerformance"
      );
    },
    returnProductivity() {
      return (
        window.location.pathname === "/admin/charts/productivity" ||
        window.location.pathname === "/salesManager/charts/productivity-report"
      );
    },
    returnProductivityV2() {
      return (
        window.location.pathname === "/admin/charts/productivity-v2"
      );
    },
    returnProductivityV3() {
      return (
        window.location.pathname === "/admin/charts/productivity-v3" ||
        window.location.pathname === "/salesManager/charts/productivity-v3")
    },
    returnMortgageReport() {
      return (
        window.location.pathname === "/admin/charts/mortgage-report"
      );
    },
    returnRequestSourcesSales() {
      return (
        window.location.pathname === "/salesManager/charts/requests-sources"
      );
    },
    returnRequestSources() {
      return (
        window.location.pathname === "/admin/charts/requests-sources"
      );
    },
    page: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    sortAr: {
      get() {
        return this.sortBy;
      },
      set(val) {
        this.$emit("update:sortBy", val);
      },
    },
    optionsObj: {
      get() {
        return this.options;
      },
      set(val) {
        this.$emit("update:options", val);
      },
    },
    results() {
      return this.pagination.count;
    },
    pages() {
      return Math.ceil(parseInt(this.pagination?.count) / parseInt(this.limit)) || 1;
      // return Math.ceil(parseInt(this.pagination['count']) / parseInt(this.limit)) || 1
    },
    myHeaders: {
      get: function () {
        let headers = [];
        headers = this.headers;
        !this.headers.some((item) => item.value === "data-table-select") &&
        this.showSelect
          ? headers.unshift({
              align: "start",
              value: "data-table-select",
              width: "5%",
            })
          : "";
        return headers;
      },
    },
  },
  methods: {
    handlePageChange(value) {
      this.page = value;
    },

    calculateSumSources() {
      let url = `${this.$store.state.url}/employee/admin/request-sources-sums`;
      Axios.post(url, this.formBody, { headers: this.request_headers() }).then((res) => {

        this.sum_of_each_source=res.data.payload.sum_of_each_source;
        this.duplicatedLogin=res.data.payload.duplicatedLogin;
      });
    },
    calculateSum() {
      let url = `${this.$store.state.url}/employee/admin/getProductivitySumAgents`;
      Axios.post(url, this.formBody, { headers: this.request_headers() }).then((res) => {
        this.dataVal.total_recived_request_sum =
          res.data.payload.total_recived_request_sum;
        this.dataVal.sent_basket_sum = res.data.payload.sent_basket_sum;
        this.dataVal.completed_request_sum = res.data.payload.completed_request_sum;
        this.dataVal.sent_basket_mortgage_sum = res.data.payload.sent_basket_mortgage_sum;
        this.dataVal.sent_basket_reject_sum = res.data.payload.sent_basket_reject_sum;
        this.dataVal.sent_basket_funding_reject_sum =
          res.data.payload.sent_basket_funding_reject_sum;
        this.dataVal.sent_basket_funding_sum = res.data.payload.sent_basket_funding_sum;
        this.dataVal.waiting_mm_status_sum = res.data.payload.waiting_mm_status_sum;
        this.dataVal.waiting_fm_status_sum = res.data.payload.waiting_fm_status_sum;
        this.dataVal.possible_to_sell_to_customer_sum = res.data.payload.possible_to_sell_to_customer_sum;
        this.dataVal.sent_basket_mortgage_reject_sum =
          res.data.payload.sent_basket_mortgage_reject_sum;
        this.dataVal.followed_basket_possible_to_sell_sum =
          res.data.payload.followed_basket_possible_to_sell_sum;
        this.dataVal.sent_basket_percentage_sum =
          res.data.payload.sent_basket_percentage_sum + "%";
        this.dataVal.sent_basket_percentage_sum =
          res.data.payload.sent_basket_percentage_sum + "%";
        this.dataVal.sent_basket_funding_percentage_sum =
          res.data.payload.sent_basket_funding_percentage_sum + "%";
        this.dataVal.sent_basket_mortgage_percentage_sum =
          res.data.payload.sent_basket_mortgage_percentage_sum + "%";
        this.dataVal.sent_basket_reject_percentage_sum =
          res.data.payload.sent_basket_reject_percentage_sum + "%";
        this.dataVal.sent_basket_funding_reject_percentage_sum =
          res.data.payload.sent_basket_funding_reject_percentage_sum + "%";
        this.dataVal.sent_basket_mortgage_reject_percentage_sum =
          res.data.payload.sent_basket_mortgage_reject_percentage_sum + "%";
        this.dataVal.sent_basket_funding_send_basket_percentage_sum =
            res.data.payload.sent_basket_funding_send_basket_percentage_sum + "%";

        this.dataVal.sent_basket_mortgage_send_basket_percentage_sum =
            res.data.payload.sent_basket_mortgage_send_basket_percentage_sum + "%";

        this.dataVal.followed_basket_possible_to_sell_percentage_sum =
            res.data.payload.followed_basket_possible_to_sell_percentage_sum + "%";
        this.dataVal.completed_request_percentage_sum =
          res.data.payload.completed_request_percentage_sum + "%";
      });
    },
    calculateSumV3() {
      let url = `${this.$store.state.url}/employee/admin/getProductivitySum`;
      Axios.post(url, this.formBody, { headers: this.request_headers() }).then((res) => {
        this.dataVal.total_recived_request_sum =
            res.data.payload.total_recived_request_sum;
        this.dataVal.sent_basket_sum = res.data.payload.sent_basket_sum;
        this.dataVal.completed_request_sum = res.data.payload.completed_request_sum;
        this.dataVal.sent_basket_mortgage_sum = res.data.payload.sent_basket_mortgage_sum;
        this.dataVal.sent_basket_reject_sum = res.data.payload.sent_basket_reject_sum;
        this.dataVal.sent_basket_funding_reject_sum =
            res.data.payload.sent_basket_funding_reject_sum;
        this.dataVal.sent_basket_funding_sum = res.data.payload.sent_basket_funding_sum;
        this.dataVal.waiting_mm_status_sum = res.data.payload.waiting_mm_status_sum;
        this.dataVal.waiting_fm_status_sum = res.data.payload.waiting_fm_status_sum;
        this.dataVal.possible_to_sell_to_customer_sum = res.data.payload.possible_to_sell_to_customer_sum;
        this.dataVal.sent_basket_mortgage_reject_sum =
            res.data.payload.sent_basket_mortgage_reject_sum;
        this.dataVal.followed_basket_possible_to_sell_sum =
            res.data.payload.followed_basket_possible_to_sell_sum;
        this.dataVal.sent_basket_percentage_sum =
            res.data.payload.sent_basket_percentage_sum + "%";
        this.dataVal.sent_basket_percentage_sum =
            res.data.payload.sent_basket_percentage_sum + "%";
        this.dataVal.sent_basket_funding_percentage_sum =
            res.data.payload.sent_basket_funding_percentage_sum + "%";
        this.dataVal.sent_basket_mortgage_percentage_sum =
            res.data.payload.sent_basket_mortgage_percentage_sum + "%";
        this.dataVal.sent_basket_reject_percentage_sum =
            res.data.payload.sent_basket_reject_percentage_sum + "%";
        this.dataVal.sent_basket_funding_reject_percentage_sum =
            res.data.payload.sent_basket_funding_reject_percentage_sum + "%";
        this.dataVal.sent_basket_mortgage_reject_percentage_sum =
            res.data.payload.sent_basket_mortgage_reject_percentage_sum + "%";
        this.dataVal.sent_basket_funding_send_basket_percentage_sum =
            res.data.payload.sent_basket_funding_send_basket_percentage_sum + "%";

        this.dataVal.sent_basket_mortgage_send_basket_percentage_sum =
            res.data.payload.sent_basket_mortgage_send_basket_percentage_sum + "%";

        this.dataVal.followed_basket_possible_to_sell_percentage_sum =
            res.data.payload.followed_basket_possible_to_sell_percentage_sum + "%";
        this.dataVal.completed_request_percentage_sum =
            res.data.payload.completed_request_percentage_sum + "%";
      });
    },

    calculateTotal(items, column) {
      let total = 0;
      for (const item of items) {
        total += item[column];
      }
      return total;
    },
    itemRowBackground(res) {
      this.newOrderId = res;
      const isStatusOpenRequest =
        res.status === "طلب تم فتحه" &&
        !res.comment &&
        !res.class_id_agent_text &&
        window.location.pathname.includes("/agent");

      const isMatchingPath =
        (res.request?.id === this.$store.state.orderRequestId ||
          res.id === this.$store.state.orderRequestId ||
          res.request_id === this.$store.state.orderRequestId) &&
        (window.location.pathname.includes("/admin") ||
          window.location.pathname.includes("/salesManager")) &&
        (this.$store.state.openOrderRequestSection ||
          this.$store.state.orderRequestDialog);

      const isMatchingRequestTasksPath =
        (res.request?.id === this.$store.state.tasksRequestId ||
          res.id === this.$store.state.tasksRequestId ||
          res.request_id === this.$store.state.tasksRequestId) &&
        (window.location.pathname.includes("/admin")||
        window.location.pathname.includes("/salesManager")) &&
        this.$store.state.openTasksRequestSection;

      const isMatchingRequestTasksDetailsPath =
        (res.request?.id === this.$store.state.tasksDetailsRequestId ||
          res.id === this.$store.state.tasksDetailsRequestId ||
          res.request_id === this.$store.state.tasksDetailsRequestId) &&
        window.location.pathname.includes("/admin") &&
        this.$store.state.openTasksDetailsRequestSection;

      if (
        isStatusOpenRequest ||
        isMatchingPath ||
        isMatchingRequestTasksPath ||
        isMatchingRequestTasksDetailsPath
      ) {
        return "openRequest";
      }
    },

    slotName(field) {
      return `item.${field.value}`;
    },
    refresh() {
      this.page = 1;
      this.$emit("refresh");
    },

    updateTempCounterOfShow(newValue) {
      this.tempCounterOfShow = newValue;
    },
    updateCounterOfShow() {
      this.$store.state.counterOfShow = this.tempCounterOfShow;
    },
    resetSelectedItems(){
      this.selectedItems = [];
    },
    
  },
  created() {
    EventBus.$on('EmptySelectedRequests', this.resetSelectedItems);
    this.page = 1;

    this.calculateSumSources();
    //this.calculateSum();
    this.calculateSumV3();


  },

  beforeCreate(){
    this.$store.state.counterOfShow = 10;
  }
};
</script>
<style lang="scss">
.openRequest {
  background-color: #f5c4c6 !important;
}

.oddRowcolor {
  background: #e3dce3 !important;
}

.v-application .elevation-1 {
  background: #ffffff 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 12px 24px #12263f08 !important;
  border: 1px solid #e2e2e4 !important;
  border-radius: 3px !important;
}

.printing {
  box-shadow: 0px 12px 24px #12263f08 !important;
  border-radius: 3px !important;
  justify-content: flex-end !important;
}

.v-menu__content {
  box-shadow: 0px 10px 25px #00000026 !important;
}

.v-card {
  border-radius: unset !important;
  border: 1px solid #c9ccd2 !important;
  box-shadow: unset !important;
}

.v-data-table th {
  font-weight: bolder !important;
  font-size: 16px !important;
  color: #444444 !important;
  vertical-align: top !important;
  padding-top: 7px !important;
  background-color: #f8f9fa;
  letter-spacing: 0px;
}

.v-data-table td {
  letter-spacing: 0px;
  font-weight: 500;
  color: #5d5d5d;
  font-size: 16px !important;
}

.v-data-table tr:nth-of-type(even) {
  border-color: #f8f9fa !important;
  font-size: 16px;
  background-color: #f8f9fa;
}

.v-data-table th .v-icon {
  margin-top: -3px !important;
  margin-right: 7px !important;
  font-size: 18px !important;
}

.v-data-table__wrapper {
  border-top: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
  border-left: 1px solid #e9e9e9;
}

.v-data-table thead tr:last-child > th {
  border-bottom: thin solid #e9e9e9 !important;
}

.v-data-table tr td {
  border-bottom: 1px solid #e9e9e9 !important;
}

.v-data-table tr:nth-of-type(even) {
  background-color: #f8f9fa;
}

.v-data-table tr td:last-child,
.v-data-table tr th:last-child {
  border-right: 1px solid #e2e2e2;
  // background-color: #ffffff;

  i {
    font-size: 34px;
  }

  button {
    padding: 0 !important;
  }
}

/*
.v-data-table tr th:last-child {
  background-color: #f8f9fa;
}
*/

@media (max-width: 990px) {
  .v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
    border-bottom: 1px solid #d1d1d1;
    padding: 17px;
  }

  .v-data-table tr td:last-child,
  .v-data-table tr th:last-child {
    border-right: 1px solid #e2e2e2;
    //background-color: transparent;
  }
}

@media (max-width: 500px) {
  .v-card > *:last-child:not(.v-btn):not(.v-chip):not(.v-avatar):not(.excluded) {
    padding: 0 !important;
  }
  .v-application--is-rtl .v-data-table__mobile-row__header,
  .v-application--is-rtl .v-data-table__mobile-row__cell {
    font-size: 14px;
    margin-bottom: 10px;
  }
}

.main__table
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  background: var(--primary-color);
  color: white !important;
  border-right: 1px solid white;
  border-bottom: 1px solid var(--primary-color) !important;
  height: 72px;
}

.main__table .v-data-table-header__icon {
  display: none;
}

.main__table .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th{
  vertical-align: middle !important;
}

.main__table .v-data-table th .v-icon {
  color: white;
}

.main__table .v-data-table__wrapper {
  border-radius: 12px 12px 0 0;
}

.main__table .v-data-table th .v-icon {
  width: 50px;
  height: 20px;
  background: white;
  border-radius: 3px;
}

.main__table .v-data-table tr:nth-of-type(even) {
  background-color: #e3dce3;
}

.main__table .v-input--selection-controls__input .v-icon {
  color: purple;
}

.table-toolbar .v-btn:not(.v-btn--round).v-size--small {
  color: white !important;
  margin-left: -5px;
}

.table-toolbar .v-btn__content {
  background: var(--primary-color);
  width: 36px;
  height: 36px;
  border-radius: 6px;
}

.main__table .v-input__slot {
  min-height: 30px !important;
  margin-top: 20px;
  border: 1px solid var(--primary-color);
}

.main__table .v-text-field--outlined.v-input--is-focused fieldset {
  height: 30px !important;
  border: none;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row),
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-family: "Material Design Icons";

  span {
    font-family: "Material Design Icons";
  }
}

.v-application .accent--text{
  color : #8E8E8E !important;
}
.v-application--is-rtl .v-rating .v-icon{
  padding: inherit !important;
}
.main__tables .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  background: #33AB5F !important;
  color: white !important;
  border-right: 1px solid white;
  border-bottom: 1px solid #33AB5F !important;
  height: 72px;
}
.main__tables_ .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  background: #FF4A4A !important;
  color: white !important;
  border-right: 1px solid white;
  border-bottom: 1px solid #FF4A4A !important;
  height: 72px;
}
.main__tables_ .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td> button {
  background-color: #FF4A4A !important;
  border-color:#FF4A4A !important;
}
.main__tables .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td> button {
  background-color: #33AB5F !important;
  border-color:#33AB5F !important;
}
</style>
